import Header from "shared/components/Header";
import { Col, Row } from "antd";
import { Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { bindInputProps } from "utils/helpers";
import { NAME_SPACES } from "shared/locales/constants";
import Form from "shared/components/Form";
import Input from "shared/components/Form/Input";
import validation from "./validation";

const Create = ({ onSubmit, cancel }) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.USER);
  const CREATE = t("CREATE", { returnObjects: true });
  const FORM = t("FORM", { returnObjects: true });
  return (
    <Formik
      initialValues={{
        name: "",
      }}
      onSubmit={onSubmit}
      validationSchema={validation(
        t(`${NAME_SPACES.ERRORS}:VALIDATIONS`, { returnObjects: true })
      )}
    >
      {({ isValid, handleSubmit, setFieldValue, values, ...formProps }) => [
        <Header
          key={"header"}
          title={CREATE.HEADER.TITLE}
          subtitle={CREATE.HEADER.ACTION}
          actions={[
            {
              text: CREATE.HEADER.DISCARD,
              onClick: cancel,
              variant: "outlined",
            },
            {
              text: CREATE.HEADER.SAVE,
              onClick: handleSubmit,
            },
          ]}
        />,
        <Row gutter={[16, 16]} key={"row"}>
          <Col span={24}>
            <Form title={FORM.GENERAL_INFO}>
              <Col lg={12}>
                <Input
                  placeholder={FORM.NAME}
                  {...bindInputProps({
                    name: "name",
                    values,
                    ...formProps,
                  })}
                />
              </Col>
            </Form>
          </Col>
        </Row>,
      ]}
    </Formik>
  );
};

export default Create;
